import Api from '@/api/api.js'
import configApi from '@/api/config/_api_config'

async function imagerieOptions() {
    try {
        const response = await configApi().post('/imagerie/access', {}, { med_access_scoped: true, timeout: 20000 })
        const token = response.data && response.data.data && response.data.data.access_token
        return token ? { med_access_scoped: true, timeout: 30000, headers: { 'X-Imagerie-Access': token } } : null
    } catch (error) {
        // Les droits attribués manuellement restent utilisables sans rôle imagerie.
        if (error.response && [401, 403].indexOf(error.response.status) !== -1) return null
        throw error
    }
}

function sansIdentiteClient(data) {
    const filters = { ...(data || {}) }
    delete filters.user_id
    return filters
}

export default {
    getExamens() {
        const promise = Api().get('/type_examens')
        return promise.then(response => response.data)
    },

    saveDemandeExamen(data) {
        const promise = Api().post('/examens/save_demande', data)
        return promise.then((response) => response.data)
    },

    editExamenRenseignementClinique(data) {
        const promise = Api().post('/examens/bulletin/edit-renseignement-clinique', data)
        return promise.then((response) => response.data)
    },

    getDemandeExamen(data) {
        const promise = Api().get('/examens/'+data.consultation_id+'/demandes')
        return promise.then(response => response.data)
    },

    deleteDemandeExamen(data) {
        const promise = Api().post('/examens/delete/demande-examen', data)
        return promise.then((response) => response.data)
    },

    deleteExamenBulletin(data) {
        const promise = Api().post('/examens/delete/bulletin-examen', data)
        return promise.then((response) => response.data)
    },

    /**
     * Ajouter un nouveau type d'examen paraclinique
     * @param {*} data 
     * @returns 
     */
    addNewExamen(data) {
        const promise = Api().post('/examens/type_examen/store', data)
        return promise.then((response) => response.data)
    },

    searchExamen(keyword){
        const promise = Api().get('type_examens/search?search_word='+keyword)
        return promise.then((response) => response.data)
    },

    getExamensMiniInfo(){
        const promise = Api().get('type_examens?mini=1')
        return promise.then((response) => response.data)
    },

    saveResultatExamen(data) {
        const promise = Api().post('/examens/store/resultat', data)
        return promise.then((response) => response.data)
    },

    async getRegistreExamen(user_id) {
        const options = await imagerieOptions()
        if (options) return (await Api().get('/imagerie/registre-legacy', options)).data
        const promise = Api().get('consultations/salle_examen/user/'+user_id+'/registre')
        return promise.then((response) => response.data)
    },

    getExamenToFill(data) { 
        const promise = Api().post('consultations/examen/remplir', data)
        return promise.then((response) => response.data)
    },

    async getExamenSalleAttente(data) {
        const options = await imagerieOptions()
        if (options) return (await Api().post('/imagerie/demandes-en-attente', sansIdentiteClient(data), options)).data
        const promise = Api().post('examens/demande-en-attente', data)
        return promise.then((response) => response.data)
    },

    deleteTypeExamen(data) { 
        const promise = Api().post('examens/type_examen/delete', data)
        return promise.then((response) => response.data)
    },

    getBulletinExamen(data) { 
        const promise = Api().post('examens/bulletin/liste-examens', data)
        return promise.then((response) => response.data)
    },

    async getExamensAttenteInterpretation(data) {
        const options = await imagerieOptions()
        if (options) return (await Api().post('/imagerie/attentes-interpretation', sansIdentiteClient(data), options)).data
        const promise = Api().post('examens/attentes-interpretation', data)
        return promise.then((response) => response.data)
    },

    saveExamenInterpretation(data) { 
        const promise = Api().post('examens/store-interpretation', data)
        return promise.then((response) => response.data)
    },

    getHistoriqueResultatExamen(data) { 
        const promise = Api().post('examens/get-recap-info/resultat-historique', data)
        return promise.then((response) => response.data)
    },

    saveClicheExamen(data) { 
        const promise = Api().post('examens/edit-cliche', data)
        return promise.then((response) => response.data)
    },
    
    shareResultatImagerieMedicale(data) { 
        const promise = Api().post('cca-mobile/imageries-resultats/'+data.reference+'/share', data)
        return promise.then((response) => response.data)
    },
}
